import { OrkiszewskiFlowRegime } from ".";
import { GRAVITY_FT_SEC } from "../../constants";
import type { PipeFrictionContext } from "../d";
import type { PipeFrictionIntermediates } from "..";

export function calculateGradientsSlug(
  tubingFrictionContext: PipeFrictionContext
): PipeFrictionIntermediates {
  const {
    fluidPropertiesContext: {
      fluidProperties: {
        liquidSuperficialVelocityFTSEC,
        liquidViscosityCP,
        mixSuperficialVelocityFTSEC,
        gasSuperficialVelocityFTSEC,
        liquidDensityLBMFT3,
        gasDensityLBMFT3
      },
      fluidFrictionProperties: {
        hydraulicDiameterFt,
        noSlipLiquidHoldupLambdaCL
      }
    },
    epsilonD,
    pipeLengthFt,
    griffithWallis
  } = tubingFrictionContext;

  const includeGriffithWallis = griffithWallis || false;
  let liquidHoldup = noSlipLiquidHoldupLambdaCL;
  if (includeGriffithWallis) {
    liquidHoldup =
      1 -
      0.5 *
        (1 +
          mixSuperficialVelocityFTSEC / 0.24384 -
          Math.sqrt(
            (1 + mixSuperficialVelocityFTSEC / 0.24384) ** 2 -
              (4 * gasSuperficialVelocityFTSEC) / 0.24384
          ));
  }

  // TODO: WHERE DO THESE GO?
  // COMMON VARIABLES REFACTORED OUT OF REGIMES
  // D191: =(D130^D220)
  const mixtureViscosityUM = liquidViscosityCP ** liquidHoldup;

  // // D222: =D63*D220+D62*(1-D220)
  // // D245: =D63*D220+D62*(1-D220)
  const mixtureDensityPM =
    liquidDensityLBMFT3 * liquidHoldup + gasDensityLBMFT3 * (1 - liquidHoldup);

  // D226: =D155/D220
  // D251: =D155/D220
  const inSituLiquidVelocityVL = liquidSuperficialVelocityFTSEC / liquidHoldup;

  // D271: ==1488*D275*D136*D269/D191
  const reynoldsTwoPhaseNumber_Re =
    (1488 * inSituLiquidVelocityVL * hydraulicDiameterFt * mixtureDensityPM) /
    mixtureViscosityUM;

  // D255: =(1/(-2*LOG10(D253/3.7065-(5.0452/D247)*LOG10(((D253^1.1098)/2.8257)+(5.8506/(D247^0.8981))))))^2
  const chenFriction =
    (1 /
      (-2 *
        Math.log10(
          epsilonD / 3.7065 -
            (5.0452 / reynoldsTwoPhaseNumber_Re) *
              Math.log10(
                epsilonD ** 1.1098 / 2.8257 +
                  5.8506 / reynoldsTwoPhaseNumber_Re ** 0.8981
              )
        ))) **
    2;

  // D259: =((D255*D251^2)/(2*D67*D136))
  const frictionGradient =
    (2 * chenFriction * inSituLiquidVelocityVL ** 2) /
    (144 * GRAVITY_FT_SEC * hydraulicDiameterFt);

  // D261: =(D245/144)*D3*SIN(D8)
  // const hydrostaticPressurePSIA = (mixtureDensityPM / 144) * hydrostaticSum;
  // D263: =D259*D3
  const frictionPressurePSIA = frictionGradient * pipeLengthFt;

  return {
    flowRegime: OrkiszewskiFlowRegime.SLUG,
    frictionPressurePSIA,
    includeGriffithWallis,
    liquidHoldup,
    mixtureViscosityUM,
    inSituLiquidVelocityVL,
    reynoldsTwoPhaseNumber_Re,
    chenFriction,
    frictionGradient,
    mixtureDensityPM
  };
}
